import React, { useState, useEffect, useCallback } from 'react';
import { useRouteMatch, useParams } from 'react-router-dom';

import CustomerInfoLinks from './CustomerInfoLinks/CustomerInfoLinks';
import CustomerInfoRoutes from './CustomerInfoRoutes/CustomerInfoRoutes';
import CompanyHeader from './CompanyHeader/CompanyHeader';
import { Loading } from 'components/common/Elements/Elements';

import { postRequest } from 'utils/requests';
import { useContent } from 'contexts/content-context';
import { setCurrentAccountData } from 'contexts/actions/contentAction';
import { useRegion } from 'contexts/RegionContext';

const CustomerInfo = () => {
  const [data, setData] = useState({});
  const [loader, setLoader] = useState(true);
  const { contentDispatch } = useContent();
  const { region } = useRegion();

  const header = {
    name: data.companyName || 'NA',
    tenantUUID: data.tenantUUID,
    status: data.status || 'NA',
    terminationStatus: data.terminationStatus,
    terminationStatusDate: data.terminationStatusDate,
    workspace: data.workspace || 'NA',
    poc: data.poc || 'NA',
    salesforceAccountId: data.salesforceAccountId || 'NA',
    info: {
      site: data.website || 'NA',
      country: data.country || 'NA',
      industry: data.industry || 'NA',
      size: data.companySize || 'NA',
      plan: data.plan || 'NA',
      type: data.customerType || 'NA',
      origin: data.source || 'NA',
      accountManager: data.accountManager || 'NA',
      customerSuccessEngineer: data.customerSuccessEngineer || 'NA',
      partnerId: data.partnerId || 'NA',
      partnerLinkable: data.partnerLinkable === true,
      isCheckpointTenant: data.tenantUUID && data.tenantUUID !== 'NA'
    }
  };

  const { url } = useRouteMatch();
  const params = useParams();

  let newUrl = url.split('/');
  newUrl.pop();
  newUrl = newUrl.join('/');

  const requestHeaderData = useCallback(
    (cancelled = false) => {
      postRequest('/customer/header', {
        customerId: params.id
      })
        .then(res => {
          if (!cancelled) {
            setData(res.body);
            contentDispatch(setCurrentAccountData(res.body));
            setLoader(false);
          }
        })
        .catch(err => {
          if (!cancelled) {
            console.log(err);
            setLoader(false);
          }
        });
    },
    // region.code is needed to trigger re-fetch when region changes
    // postRequest internally uses the region via setApiRegion
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [params.id, contentDispatch, region.code]
  );

  useEffect(() => {
    let cancelled = false;
    requestHeaderData(cancelled);
    return () => (cancelled = true);
  }, [requestHeaderData]);

  if (loader) {
    return <Loading />;
  }

  return (
    <>
      <CompanyHeader
        data={header}
        customerId={params.id}
        requestHeaderData={requestHeaderData}
      />
      <CustomerInfoLinks
        url={newUrl}
        hasChilds={data.hasChilds}
        hasArr={data.hasArrActivity}
      />
      <CustomerInfoRoutes
        url={newUrl}
        customerId={params.id}
        status={header.status}
        plan={header.info.plan}
      />
    </>
  );
};

export default CustomerInfo;
